import { isValidGtmId } from '../gtmId'

type GtmWindow = typeof globalThis & {
  dataLayer?: Record<string, unknown>[]
  document?: Document
}

const loadedGtmIds = new Set<string>()

export const resetGtmContainerForTests = () => {
  loadedGtmIds.clear()
}

export const ensureGtmContainer = (gtmId: string | undefined | null): boolean => {
  if (!isValidGtmId(gtmId)) return false
  const gtmWindow = globalThis as GtmWindow
  if (typeof gtmWindow.document === 'undefined') return false

  const id = gtmId.trim()
  gtmWindow.dataLayer = gtmWindow.dataLayer || []

  if (loadedGtmIds.has(id)) {
    return true
  }

  gtmWindow.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })

  const script = gtmWindow.document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtm.js?id=${id}`
  gtmWindow.document.head.appendChild(script)
  loadedGtmIds.add(id)
  return true
}
